var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Types } from '../../actions/AuthActions';
import { initialAuthState } from '../../state';
export var authReducer = function (state, action) {
    if (state === void 0) { state = initialAuthState; }
    switch (action.type) {
        case Types.SEND_CODE:
            return __assign(__assign({}, state), { sendingCode: true });
        case Types.SENT_CODE:
            return __assign(__assign({}, state), { sendingCode: false });
        case Types.VERIFY_CODE:
            return __assign(__assign({}, state), { verifyingCode: true });
        case Types.VERIFIED_CODE:
            return __assign(__assign({}, state), { verifyingCode: false, verifiedCode: action.payload });
        case Types.ERROR:
            return __assign(__assign({}, state), { error: action.payload });
        default:
            return __assign({}, state);
    }
};
//# sourceMappingURL=index.js.map